import { useState, useEffect } from 'react';
import HeroSection from './components/HeroSection';
import AboutSection from './components/AboutSection';
import ScheduleSection from './components/ScheduleSection';
import AtmosphereSection from './components/AtmosphereSection';
import TheaterSection from './components/TheaterSection';
import MapSection from './components/MapSection';
import FAQSection from './components/FAQSection';
import SponsorsSection from './components/SponsorsSection';
import CTASection from './components/CTASection';
import Footer from './components/Footer';
import RegistrationModal from './components/RegistrationModal';

export default function HomePage() {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [isScrolled, setIsScrolled] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const openModal = () => setIsModalOpen(true);
  const closeModal = () => setIsModalOpen(false);

  return (
    <div className="min-h-screen bg-[#F8F7F4]">
      <HeroSection onRegisterClick={openModal} isScrolled={isScrolled} />
      <AboutSection onRegisterClick={openModal} />
      <ScheduleSection onRegisterClick={openModal} />
      <AtmosphereSection onRegisterClick={openModal} />
      <TheaterSection />
      <MapSection />
      <FAQSection />
      <SponsorsSection />
      <CTASection onRegisterClick={openModal} />
      <Footer />
      <RegistrationModal isOpen={isModalOpen} onClose={closeModal} />
    </div>
  );
}